import { useState, useEffect } from "react";

function removeCurrencySymbol(currencyString) {
  const currencyRegex = /(?:^\D+)|(?:\D+$)/;
  const currencySymbol = currencyString?.match(currencyRegex)[0];
  const value = currencyString?.replace(currencyRegex, "");
  return { currencySymbol, value };
}

const currencyParser = (currencyCode, country, formattedString) => {
  // Ensure formattedString is a valid string before proceeding
  const formattedPrice = formattedString ? formattedString.replace(/(0\.00|0,00|0)/, currencyCode) : "";

  let priceObject = {
    symbolLeft: true,
    number: 0,
    cents: "00",
    symbol: "",
    hasCents: true,
  };

  let splitedValue;

  if (formattedPrice.includes(",")) {
    splitedValue = formattedPrice.split(",");
  } else {
    splitedValue = formattedPrice.split(".");
  }

  const currencyRegex = /(?:^\D+)|(?:\D+$)/;
  const firstItemHasSymbol = currencyRegex.test(splitedValue[0]?.trim());
  if (firstItemHasSymbol) {
    const splitedFirstNumber = removeCurrencySymbol(splitedValue[0]?.trim());

    priceObject = {
      ...priceObject,
      symbolLeft: true,
      number: Number(splitedFirstNumber.value),
      cents: splitedValue[1] ? splitedValue[1] : "00",
      symbol: splitedFirstNumber.currencySymbol?.replace(/\s+$/, "\u00A0"),
    };
  } else {
    const splitedSecondNumber = removeCurrencySymbol(splitedValue[1]?.trim());

    priceObject = {
      ...priceObject,
      symbolLeft: false,
      number: splitedValue[0],
      cents: splitedSecondNumber.value,
      symbol: splitedSecondNumber.currencySymbol?.replace(/^\s+/, "\u00A0"),
    };
  }

  if (country === "JPY") {
    priceObject = {
      ...priceObject,
      hasCents: false,
    };
  }

  return priceObject;
};

const useReducedProductsPrice = (product, currencyCode, formattedString) => {
  const [price, setPrice] = useState("0.00");
  const [promoPrice, setPromoPrice] = useState("0.00");
  const [oldPrice, setOldPrice] = useState("0.00");

  const [priceObject, setPriceObject] = useState(null);
  const [promoPriceObject, setPromoPriceObject] = useState(null);

  useEffect(() => {
    if (product) {
      setPrice(Number(product?.price).toFixed(2));
      setOldPrice(formattedString?.replace(/(0\.00|0,00|0)/, product.old_price));
      setPromoPrice(Number(product?.promo_discounted_price)?.toFixed(2));
    }
  }, [product]);

  useEffect(() => {
    if (price && formattedString) {
      const parsedPriceObject = currencyParser(price, currencyCode, formattedString);
      setPriceObject(parsedPriceObject);
    }
  }, [price, formattedString, currencyCode]);

  useEffect(() => {
    if (promoPrice && formattedString) {
      const parsedPromoPriceObject = currencyParser(promoPrice, currencyCode, formattedString);
      setPromoPriceObject(parsedPromoPriceObject);
    }
  }, [promoPrice, currencyCode]);

  return { price, priceObject, promoPriceObject, oldPrice };
};

export { removeCurrencySymbol, currencyParser, useReducedProductsPrice };
